<template>
  <div>
    <v-navigation-drawer
      v-model="drawer"
      enable-resize-watcher
      fixed
      app
      class="grey darken-4"
    >
      <side-drawer></side-drawer>
    </v-navigation-drawer>
    <v-toolbar
      app
      color="primary"
      class="elevation-1"
    >
      <v-btn icon @click="goBack()">
        <v-icon>keyboard_arrow_left</v-icon>
      </v-btn>
      <v-spacer></v-spacer>
      <v-toolbar-title class="white--text">Sales Report</v-toolbar-title>
      <v-spacer></v-spacer>
    </v-toolbar>
    <v-content ref="contentDiv">
      <v-container grid-list-lg>
        <v-layout fluid wrap>
          <v-flex xs6 sm1>
            <v-text-field
              label="Order No"
              v-model="txtSalesOrderNo"
            ></v-text-field>
          </v-flex>
          <v-flex xs6 sm1>
            <v-text-field
              label="Email"
              v-model="txtEmail"
            ></v-text-field>
          </v-flex>
          <v-flex xs4 sm2>
            <v-select
              :items="paymentStatuses"
              label="Payment Status"
              v-model="cboPaymentStatus"
            ></v-select>
          </v-flex>
          <v-flex xs4 sm1>
            <v-select
              :items="deliveryStatuses"
              item-text="title"
              item-value="key"
              label="Delivery Status"
              v-model="cboDeliveryStatus"
            ></v-select>
          </v-flex>
          <v-flex xs4 sm1>
            <v-select
              :items="withVouchers"
              item-text="title"
              item-value="key"
              label="With Voucher"
              v-model="cboWithVoucher"
            ></v-select>
          </v-flex>
          <v-flex xs6 sm2>
            <v-menu
              ref="menu1"
              :close-on-content-click="false"
              v-model="dtPicker1"
              :nudge-right="40"
              :return-value.sync="date1"
              lazy
              transition="scale-transition"
              offset-y
              full-width
              min-width="290px"
            >
              <v-text-field
                slot="activator"
                v-model="date1"
                label="Payment Date from"
                prepend-icon="event"
                clearable
                readonly
              ></v-text-field>
              <v-date-picker v-model="date1" no-title scrollable @input="$refs.menu1.save(date1)"></v-date-picker>
            </v-menu>
          </v-flex>
          <v-flex xs6 sm2>
            <v-menu
              ref="menu2"
              :close-on-content-click="false"
              v-model="dtPicker2"
              :nudge-right="40"
              :return-value.sync="date2"
              lazy
              transition="scale-transition"
              offset-y
              full-width
              min-width="290px"
            >
              <v-text-field
                slot="activator"
                v-model="date2"
                label="Payment Date to"
                prepend-icon="event"
                clearable
                readonly
              ></v-text-field>
              <v-date-picker v-model="date2" no-title scrollable @input="$refs.menu2.save(date2)"></v-date-picker>
            </v-menu>
          </v-flex>
          <v-flex xs6 sm1>
            <v-btn
              outline
              block
              @click="getReport(txtEmail, txtSalesOrderNo, cboPaymentStatus, cboDeliveryStatus, cboWithVoucher, date1, date2)"
            >
              <v-icon>search</v-icon>
            </v-btn>
          </v-flex>
          <v-flex xs6 sm1>
            <v-btn
              outline
              block
              @click="getReport(txtEmail, txtSalesOrderNo, cboPaymentStatus, cboDeliveryStatus, cboWithVoucher, date1, date2, '', 0, 'csv')"
            >
              CSV
            </v-btn>
          </v-flex>
          <v-flex xs12 class="text-xs-center">
            <v-data-table
              :items="report"
              hide-actions
              class="elevation-1"
            >
              <template slot="headers">
                <tr>
                  <th class="text-xs-center subheading font-weight-bold" rowspan="2">
                    Sales Order No
                  </th>
                  <th class="text-xs-center subheading font-weight-bold" rowspan="2">
                    Invoice No
                  </th>
                  <th class="text-xs-center subheading font-weight-bold" rowspan="2">
                    Type
                  </th>
                  <th class="text-xs-center subheading font-weight-bold" rowspan="2">
                    Creation Date Time
                  </th>
                  <th class="text-xs-center subheading font-weight-bold" rowspan="2">
                    Payment Date Time
                  </th>
                  <th class="text-xs-center subheading font-weight-bold" rowspan="2">
                    Payment Status
                  </th>
                  <th class="text-xs-center subheading font-weight-bold" rowspan="2">
                    Payment Methods
                  </th>
                  <th class="text-xs-center subheading font-weight-bold" rowspan="2">
                    Seller Store List
                  </th>
                  <th class="text-xs-center subheading font-weight-bold" rowspan="2">
                    Delivery Status
                  </th>
                  <th class="text-xs-center subheading font-weight-bold" rowspan="2">
                    Delivery Date Time
                  </th>
                  <th class="text-xs-center subheading font-weight-bold" rowspan="2">
                    Total Weight (Kg)
                  </th>
                  <th class="text-xs-center subheading font-weight-bold" rowspan="2">
                    Order Currency
                  </th>
                  <th class="text-xs-center subheading font-weight-bold" rowspan="2">
                    Total Sales
                  </th>
                  <th class="text-xs-center subheading font-weight-bold" rowspan="2">
                    Total Voucher
                  </th>
                  <th class="text-xs-center subheading font-weight-bold" rowspan="2">
                    Vouchers
                  </th>
                  <th class="text-xs-center subheading font-weight-bold" rowspan="2">
                    Delivery Cost
                  </th>
                  <th class="text-xs-center subheading font-weight-bold" rowspan="2">
                    Total Payment
                  </th>
                  <th class="text-xs-center subheading font-weight-bold" rowspan="2">
                    Total Fee
                  </th>
                  <th class="text-xs-center subheading font-weight-bold" rowspan="2">
                    Billing Name
                  </th>
                  <th class="text-xs-center subheading font-weight-bold" rowspan="2">
                    Billing Email
                  </th>
                  <th class="text-xs-center subheading font-weight-bold" rowspan="2">
                    Billing Country
                  </th>
                  <th class="text-xs-center subheading font-weight-bold" rowspan="2">
                    Shipping Name
                  </th>
                  <th class="text-xs-center subheading font-weight-bold" rowspan="2">
                    Shipping Email
                  </th>
                  <th class="text-xs-center subheading font-weight-bold" rowspan="2">
                    Shipping Country
                  </th>
                  <th class="text-xs-center subheading font-weight-bold" colspan="5" v-for="seller in sellers" :key="seller.sellerUserId">
                    {{ seller.storeName + ' - ' + seller.storeCountryName }}
                  </th>
                </tr>
                <tr>
                  <template v-for="seller in sellers">
                    <th class="text-xs-center subheading font-weight-bold" :key="'title1_' + seller.sellerUserId">
                      Delivery Status
                    </th>
                    <th class="text-xs-center subheading font-weight-bold" :key="'title2_' + seller.sellerUserId">
                      Sales Amount
                    </th>
                    <th class="text-xs-center subheading font-weight-bold" :key="'title3_' + seller.sellerUserId">
                      Delivery Cost
                    </th>
                    <th class="text-xs-center subheading font-weight-bold" :key="'title4_' + seller.sellerUserId">
                      Remittance Amount
                    </th>
                    <th class="text-xs-center subheading font-weight-bold" :key="'title5_' + seller.sellerUserId">
                      Fee Amount
                    </th>
                  </template>
                </tr>
              </template>
              <template slot="items" slot-scope="props">
                <tr :class="(props.index % 2 === 0 ? 'row1' : 'row2')">
                  <td class="text-xs-center"><router-link :to="'/order/' + props.item.salesOrderNo" target="_blank" class="white--text">{{ props.item.salesOrderNo }}</router-link></td>
                  <td class="text-xs-center">{{ props.item.invoiceNo }}</td>
                  <td class="text-xs-center">{{ props.item.type | allCaps }}</td>
                  <td class="text-xs-center">{{ props.item.createdDateTime | formatDate('DD-MM-YYYY HH:mm:ss', profile.gmtTimezone) }}</td>
                  <td class="text-xs-center">{{ props.item.paidDateTime | formatDate('DD-MM-YYYY HH:mm:ss', profile.gmtTimezone) }}</td>
                  <td :class="(props.item.paymentStatus === 'chargeback' ? 'red--text' : '') + ' text-xs-center'">{{ props.item.paymentStatus | allCaps }}</td>
                  <td class="text-xs-center">
                    <span v-for="methodId in props.item.paymentMethodIds.split(' ')" :class="(methodId.substring(0, 12) === 'BANKTRANSFER' && methodId.length > 12 ? 'amber--text' : '') + ' mr-3'" :key="methodId">
                      {{ methodId }}
                    </span>
                  </td>
                  <td class="text-xs-center">
                    <div v-for="seller in props.item.sellerNames" class="mt-2 mb-2" :key="seller">
                      {{ seller }}
                    </div>
                  </td>
                  <td class="text-xs-center">{{ props.item.deliveryStatus | allCaps }}</td>
                  <td class="text-xs-center">{{ props.item.deliveryDateTime | formatDate('DD-MM-YYYY HH:mm:ss', profile.gmtTimezone) }}</td>
                  <td class="text-xs-center">{{ formatPrice(props.item.totalWeight) }}</td>
                  <td class="text-xs-center">{{ props.item.currencyCode }}</td>
                  <td class="text-xs-center">{{ formatPrice(props.item.totalSales) }}</td>
                  <td class="text-xs-center">{{ formatPrice(props.item.totalVoucher) }}</td>
                  <td class="text-xs-center">
                    <div v-for="voucher in props.item.vouchers" class="mt-2 mb-2" :key="voucher.name">
                      {{ voucher.name + ' (USD ' + formatPrice(voucher.discountAmountInBase) + ')' }}
                    </div>
                  </td>
                  <td class="text-xs-center">{{ formatPrice(props.item.deliveryCost) }}</td>
                  <td class="text-xs-center">{{ formatPrice(props.item.totalPayment) }}</td>
                  <td class="text-xs-center">{{ formatPrice(props.item.totalPaymentFee) }}</td>
                  <td class="text-xs-center">{{ props.item.billingName }}</td>
                  <td class="text-xs-center">{{ props.item.billingEmail }}</td>
                  <td class="text-xs-center">{{ props.item.billingCountry }}</td>
                  <td class="text-xs-center">{{ props.item.shippingName }}</td>
                  <td class="text-xs-center">{{ props.item.shippingEmail }}</td>
                  <td class="text-xs-center">{{ props.item.shippingCountry }}</td>
                  <template v-for="(sellerItem, itemIndex) in props.item.sellers">
                    <template v-if="sellerItem !== null">
                      <td class="text-xs-center" :key="'col1_' + itemIndex">{{ sellerItem.deliveryStatus | allCaps }}</td>
                      <td class="text-xs-center" :key="'col2_' + itemIndex">{{ formatPrice(sellerItem.totalAmountInBase) }}</td>
                      <td class="text-xs-center" :key="'col3_' + itemIndex">{{ formatPrice(sellerItem.deliveryCostInBase) }}</td>
                      <td class="text-xs-center" :key="'col4_' + itemIndex">{{ formatPrice(sellerItem.remittanceAmountInBase) }}</td>
                      <td class="text-xs-center" :key="'col5_' + itemIndex">{{ formatPrice(sellerItem.feeAmountInBase) }}</td>
                    </template>
                    <template v-else>
                      <td class="text-xs-center" colspan="5" :key="itemIndex"></td>
                    </template>
                  </template>
                </tr>
              </template>
            </v-data-table>
          </v-flex>
          <v-flex xs12 sm3 class="text-xs-left">
            <div v-if="sellers && sellers.length > 0" class="mb-5">
              <table cellspacing="8">
                <tr>
                  <td class="font-weight-bold">Seller</td>
                  <td class="font-weight-bold">Shipped</td>
                  <td class="font-weight-bold">Pending</td>
                </tr>
                <tr v-for="seller in sellers" :key="seller.sellerUserId">
                  <td>
                    <!--<div class="font-weight-bold">{{ seller.storeCountryName }}</div>-->
                    <div>{{ seller.storeName }}</div>
                  </td>
                  <td class="subheading font-weight-bold green--text">{{ def.currency.sign + formatPrice(seller.totalShippedAmountInBase) }}</td>
                  <td class="subheading font-weight-bold orange--text">{{ def.currency.sign + formatPrice(seller.totalPendingAmountInBase) }}</td>
                </tr>
                <tr>
                  <td colspan="3">
                    <hr />
                  </td>
                </tr>
                <tr>
                  <td class="font-weight-bold">Total</td>
                  <td class="font-weight-bold green--text">{{ def.currency.sign + formatPrice(totalShippedSales) }}</td>
                  <td class="font-weight-bold orange--text">{{ def.currency.sign + formatPrice(totalPendingSales) }}</td>
                </tr>
              </table>
            </div>
            <div>Total Shipping Received: <span class="subheading font-weight-bold">{{ def.currency.sign + formatPrice(totalShippingCost) }}</span></div>
            <div>Total Voucher: <span class="subheading font-weight-bold">{{ def.currency.sign + formatPrice(totalVoucher) }}</span></div>
            <div>Total Chargeback: <span class="subheading font-weight-bold red--text">{{ def.currency.sign + formatPrice(totalChargeback) }}</span></div>
          </v-flex>
          <v-flex xs12 sm3 class="text-xs-center pt-3">
            Showing {{ listOffset + 1 }} - {{ listOffset + report.length }} of {{ listTotal }}
          </v-flex>
          <v-flex sm3 xs6>
            <v-btn
              block
              outline
              :disabled="listOffset <= 0"
              @click="getReport(txtEmail, txtSalesOrderNo, cboPaymentStatus, cboDeliveryStatus, cboWithVoucher, date1, date2, '', (listOffset-listLimit <= 0 ? 0 : listOffset-listLimit))"
            >
              Prev
            </v-btn>
          </v-flex>
          <v-flex sm3 xs6>
            <v-btn
              block
              outline
              :disabled="listOffset + listLimit >= listTotal"
              @click="getReport(txtEmail, txtSalesOrderNo, cboPaymentStatus, cboDeliveryStatus, cboWithVoucher, date1, date2, '', listOffset+listLimit)"
            >
              Next
            </v-btn>
          </v-flex>
        </v-layout>
      </v-container>
      <v-dialog
        v-model="loading"
        hide-overlay
        persistent
        width="220"
      >
        <loading></loading>
      </v-dialog>
    </v-content>
  </div>
</template>

<style scoped>
form {
  width: 100%;
}
</style>

<script>
import SideDrawer from '@/components/SideDrawer.vue'
import Loading from '@/components/Loading.vue'
import router from '../router'
import downloadjs from 'downloadjs'
import axios from 'axios'
import moment from 'moment'

export default {
  components: {
    SideDrawer,
    Loading
  },
  data () {
    return {
      profile: this.$store.getters.getProfile,
      def: this.$store.getters.getDef,
      user: null,
      drawer: false,
      loading: false,
      txtSalesOrderNo: '',
      txtEmail: '',
      cboPaymentStatus: 'paid, credit, chargeback',
      paymentStatuses: ['', 'none', 'pending', 'partial', 'paid, credit, chargeback', 'in-verification', 'rejected', 'chargeback'],
      cboDeliveryStatus: '',
      deliveryStatuses: [
        {
          key: '',
          title: 'all'
        },
        {
          key: 'sent',
          title: 'sent'
        },
        {
          key: 'pending, partial',
          title: 'pending, partial'
        }
      ],
      cboWithVoucher: '',
      withVouchers: [
        {
          key: '',
          title: 'all'
        },
        {
          key: 'with',
          title: 'With Voucher'
        },
        {
          key: 'without',
          title: 'Without Voucher'
        }
      ],
      date1: moment().format('YYYY-MM-01'),
      date2: moment().format('YYYY-MM-DD'),
      dtPicker1: false,
      dtPicker2: false,
      report: [],
      listLimit: 10,
      listOffset: 0,
      listTotal: 0,
      totalShippedSales: 0,
      totalPendingSales: 0,
      totalVoucher: 0,
      totalShippingCost: 0,
      totalChargeback: 0,
      sellers: []
    }
  },

  mounted () {
    this.openDrawerForDesktop()
    this.getReport(this.txtEmail, this.txtSalesOrderNo, this.cboPaymentStatus, this.cboDeliveryStatus, this.cboWithVoucher, this.date1, this.date2)
    this.disableBottomDetector()
  },

  methods: {
    resetReportData: function () {
      this.report = []
      this.listLimit = 10
      this.listOffset = 0
      this.listTotal = 0
      this.totalShippedSales = 0
      this.totalPendingSales = 0
      this.totalVoucher = 0
      this.totalShippingCost = 0
      this.totalChargeback = 0
      this.sellers = []
    },
    getReport: function (email = '', orderNo = '', paymentStatus = '', deliveryStatus = '', withVoucher = '', date1 = '', date2 = '', sort = '', offset = 0, format = 'json') {
      var _this = this
      var promise = new Promise(function (resolve, reject) {
        _this.loading = true

        // clean parameters
        paymentStatus = paymentStatus.replace(', ', ',')
        deliveryStatus = deliveryStatus.replace(', ', ',')
        if (!date1) {
          date1 = ''
        }
        if (!date2) {
          date2 = ''
        }

        // format time
        if (date1.length > 0) {
          date1 = date1 + ' 00:00:00'
        }
        if (date2.length > 0) {
          date2 = date2 + ' 23:59:59'
        }

        axios.get(process.env.VUE_APP_API_ROOT + '/v1/report/sales?email=' + email + '&order_no=' + orderNo + '&payment_status=' + paymentStatus + '&delivery_status=' + deliveryStatus + '&with_voucher=' + withVoucher + '&min_paid_datetime=' + date1 + '&max_paid_datetime=' + date2 + '&sort=' + sort + '&offset=' + offset + '&format=' + format)
          .then(resp => {
            _this.loading = false
            console.log(resp.data)
            if (format === 'csv') {
              downloadjs(resp.data, 'report.csv', resp.headers['content-type'])
            } else {
              if (resp.data.status === 'success') {
                _this.report = resp.data.data
                _this.sellers = resp.data.sellers
                _this.listLimit = resp.data.limit
                _this.listOffset = resp.data.offset
                _this.listTotal = resp.data.total
                _this.totalShippedSales = resp.data.totalShippedSales
                _this.totalPendingSales = resp.data.totalPendingSales
                _this.totalVoucher = resp.data.totalVoucher
                _this.totalShippingCost = resp.data.totalShippingCost
                _this.totalChargeback = resp.data.totalChargeback
              } else {
                console.log('unable to load report: ' + resp.data.message)
              }
            }
            resolve()
          })
          .catch(function (error) {
            if (error.response) {
              console.log(error.response.status)
              _this.resetReportData()
              if (error.response.status === 401) {
                router.push('/login?next=' + _this.$route.fullPath)
                reject(error.response.status)
              } else if (error.response.status === 403) {
                _this.showAlert(error)
                reject(error.response.status)
              } else {
                _this.showAlert('Unable to load report, please try date range within 60 days')
                reject(error.response.status)
              }
              _this.loading = false
            }
          })
      })
      return promise
    }
  }
}
</script>
